import { FC, useEffect } from "react";
import Seccess from "../../../assets/icon/Seccess";
import {
  setFeedbackModal,
  setSuccessMessageModal,
} from "../../../store/slices/main";
import { useAppDispatch } from "../../../hooks/redux-hooks";

const SuccessMessageModal: FC = () => {
  const dispatch = useAppDispatch();

  // Закрити модалку через 3 секунди
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setSuccessMessageModal(false));
    }, 3000);

    return () => clearTimeout(timer); // очищення таймера при розмонтуванні
  }, [dispatch]);

  return (
    <div className="w-full h-full flex justify-center items-center px-4 sm:px-0">
      <div className="w-full max-w-md sm:max-w-xl bg-white rounded-lg p-4 sm:p-6">
        <div className="w-full flex flex-col items-center text-center">
          <Seccess />
          <h3 className="pt-4 pb-6 text-lg sm:text-xl font-bold">
            Дякуємо за зв'язок! Відповімо якнайшвидше 🙌
          </h3>
        </div>
        <div className="flex justify-center">
          <button
            onClick={() => {
              dispatch(setSuccessMessageModal(false));
              dispatch(setFeedbackModal(true));
            }}
            type="button"
            className="mt-2 px-4 py-2 bg-gray text-sm font-semibold rounded-md hover:bg-orange-dark transition"
          >
            Написати ще
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessageModal;
